import React from 'react'
// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes'

type Props = React.PropsWithChildren<unknown>

export const ErrorText = styled.div`
  color: ${colors.red300};
  font-size: 0.75rem;
  margin-top: 4px;
  text-align: left;
`

export const ErrorMessageWrapper = styled.div<{ isPassword?: boolean }>`
  bottom: ${({ isPassword }) => (isPassword ? -34 : -20)}px;
  position: absolute;
`

const ErrorMessage: React.FC<Props> = ({ children }) => <ErrorText>{children}</ErrorText>

export default ErrorMessage
